import { z } from "zod"
import { apiResponseSchema, baseResponseSchema } from "./shared"
import { userSchema } from "./user"

export const authSessionSchema = userSchema.extend({
  accessToken: z.string().optional(),
  refreshToken: z.string().optional(),
  token: z.string().optional(),
})

export const authSessionResponseSchema = z.union([
  apiResponseSchema(authSessionSchema),
  authSessionSchema,
  baseResponseSchema.extend({ data: authSessionSchema }).passthrough(),
])

export const authUserResponseSchema = z.union([
  apiResponseSchema(userSchema),
  userSchema,
  baseResponseSchema.extend({ data: userSchema }).passthrough(),
])

export const authGenericResponseSchema = baseResponseSchema

// Form validation schemas
export const loginFormSchema = z.object({
  identifier: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Email, username, or phone is required")
  ),
  password: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(8, "Password must be 8 characters or more")
  ),
})

const usernameSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(
    /^[a-z0-9](?:[a-z0-9_]*[a-z0-9])?$/,
    "Username must be 3-30 characters: lowercase letters, numbers, and underscores"
  )
  .min(3, "Username must be at least 3 characters")
  .max(30, "Username must be at most 30 characters")

export const signupFormSchema = z.object({
  email: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Email is required").email("Email is invalid")
  ),
  password: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(8, "Password must be 8 characters or more")
  ),
  name: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Full Name is required")
  ),
  phoneNumber: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Phone number is required")
  ),
  username: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.union([z.literal(""), usernameSchema])
  ),
  image: z.string().nullish(),
  imageRef: z.string().nullish(),
  userType: z.union([z.string(), z.array(z.string())]).nullish(),
})

export const forgotPasswordFormSchema = z.object({
  email: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Email is required").email("Email is invalid")
  ),
})

export const resetPasswordFormSchema = z.object({
  code: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Required")
  ),
  newPassword: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(8, "Must be 8 characters or more")
  ),
  confirmNewPassword: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Required")
  ),
}).refine((data) => data.newPassword === data.confirmNewPassword, {
  message: "Passwords must match",
  path: ["confirmNewPassword"],
})

export const verifyCodeFormSchema = z.object({
  verifyCode: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Required")
  ),
})
export const addAdminFormSchema = z.object({
  email: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Email is required").email("Email is invalid")
  ),
  name: z.preprocess(
    (val) => (val === undefined || val === null ? "" : val),
    z.string().min(1, "Full Name is required")
  ),
})
